import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  MODELO_TABELA_SDA_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_TABELA_SDA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_TABELA_SDA_ENDPOINT,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [MODELO_TABELA_SDA_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [MODELO_TABELA_SDA_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_TABELA_SDA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_TABELA_SDA_ENDPOINT],
    id
  );
}
